import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import '../../stylesheets/components/header.scss';
import _ from 'lodash';
import { withRouter, Link } from 'react-router-dom';
import SearchBar from '../SearchBar/index.jsx';
import {
  generateSession,
  destroySession
} from '../../services/Api/User/UserSessionService';
import {
  HEADER_SEARCH_REGEX,
  MENU_TYPE_FUNCTION,
  MENU_TYPE_LINK,
  NAVBAR_SIGNUP_MODAL,
  MENU_CHECK_LANG,
  MENU_CHECK_USER,
  HAMBURGER_MENU_MODAL,
  MENU_CHECK_ALLOW_HOME_DELIVERY,
  INTELLIMIZE_LOYALTY_SIGN_UP_STARTED,
  INTELLIMIZE_HOW_IT_WORKS_CLICK
} from '../../constants/defaults';
import routes from '../../constants/route';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import loadable from '@loadable/component';
import Menu from './MenuList';
import { logoutClearStore } from '../../actions/auth';
import { modalActions } from '../../reducers/modalSlice';
import { getReferrerDetails } from '../../services/Api/Referral/ReferralService';
import SocialApps from '../SocialApps';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { logOutUser2 } from '../../services/Api/User/UserService';
import { createProspectContact } from '../../services/Api/Coupon/CouponService';
import { AuthContext } from '../../Contexts';
import toast from '../Toaster/toast';
import LazyImageWithNoscript from '../common/LazyImageWithNoscript';

const AuthenticatedModal = loadable(() =>
  import('../HomeDeliveryNew/AuthenticateModal')
);
const Login = loadable(() => import('../Login'));
const HamburgerMenu = loadable(() => import('../Header/HamburgerMenu'));
const LoginErrorPopup = loadable(() => import('./LoginErrorPopup.jsx'));
const Loyalty = loadable(() => import('../Loyalty/index.jsx'));
const { API } = require('../../config/' + process.env.REACT_APP_ENV);

let validNavigation = false;

const Header = ({
  t,
  i18n,
  location,
  history,
  userPoints,
  onLogOut,
  isMobileDevice,
  ...props
}) => {
  const [showMobileSearchBar, setShowMobileSearchBar] = useState(false);
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);
  const [showMemberMenu, setShowMemberMenu] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [isDrugPageLoading, setIsDrugPageLoading] = useState(false);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [referrerUser, setReferrerUser] = useState({});
  const [isSigninClick, setIsSigninClick] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [scrollAdded, setScrollAdded] = useState(false);
  const [visibleQRCode, setVisibleQRCode] = useState(false);

  const signInModal = useRef(null);
  const signInButton = useRef(null);
  const signInModalAccessibility = useRef(null);
  const memberAccessibility = useRef(null);
  const userData = useContext(AuthContext)?.userData;
  const userName = userData?.firstName;
  const referralCode = userData?.referralCode;
  const { pathname = '' } = location;
  let lang = i18n.language;
  let unlisten;

  useEffect(() => {
    unlisten = history.listen(() => {
      // Added delay to handle redirection first.
      setTimeout(() => {
        validNavigation = false;
      }, 500);
    });
    (async () => {
      await createProspectContact(!_.isEmpty(userName));
    })();
    generateAndAutoDestroySession();
    const { pathname } = location;
    if (
      pathname === '/' ||
      pathname === '/es' ||
      pathname === '/home-new' ||
      pathname === '/es/home-new' ||
      pathname.match(HEADER_SEARCH_REGEX)
    ) {
      window.addEventListener('scroll', handleSearchVisibility);
    } else {
      setShowSearch(true);
    }

    return () => {
      unlisten();
      const pathname = location;
      if (!_.isEmpty(pathname)) {
        if (
          pathname === '/' ||
          pathname === '/es' ||
          String(pathname).match(/browse-prescriptions|buscar-medicamentos/)
        ) {
          window.removeEventListener('scroll', handleSearchVisibility());
        }
      }
    };
  }, []);

  useEffect(() => {
    const { pathname = '' } = location;
    if (_.isHeaderAndFooterVisible(pathname) && _.isHeaderVisible(pathname))
      document.body.style.overflow =
        isSignupModalOpen || showMobileSearchBar ? 'hidden' : '';
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = showHamburgerMenu ? 'hidden' : '';
  }, [showHamburgerMenu]);

  useEffect(() => {
    if (document.getElementsByClassName('fixedactionButton').length > 0) {
      if (showMobileSearchBar) {
        document.getElementsByClassName('fixedactionButton')[0].style[
          'display'
        ] = 'none';
      } else {
        document.getElementsByClassName('fixedactionButton')[0].style[
          'display'
        ] = 'block';
      }
    }
  }, [showMobileSearchBar]);

  const generateAndAutoDestroySession = async () => {
    await generateSession(!_.isEmpty(userName));

    // Make sure it's only browser close
    document.addEventListener('keypress', event => {
      if (event.keyCode === 116) {
        validNavigation = true;
      }
    });
    document.addEventListener('click', event => {
      if (
        event.target.tagName &&
        (event.target.tagName === 'A' ||
          (event.target.parentNode && event.target.parentNode.tagName === 'A'))
      ) {
        validNavigation = true;
      }
    });

    // Attach unload event to check browser close.
    window.addEventListener('beforeunload', async () => {
      if (!validNavigation) {
        await destroySession(
          _.getCookie('prospect-id'),
          _.getCookie('session-guid')
        );
      }
    });
  };

  const handleSearchVisibility = () => {
    if (!scrollAdded) {
      let element = document.getElementById('desktTopSearchbar');
      if (!_.isInViewport(element)) {
        setShowSearch(true);
        setScrollAdded(true);
      }
    }
    let element = document.getElementById('desktTopSearchbar');
    if (_.isInViewport(element)) {
      setShowSearch(false);
      setScrollAdded(false);
    }
  };

  const onClickOpenMemberMenu = event => {
    event.preventDefault();
    setShowMemberMenu(!showMemberMenu);
    memberAccessibility &&
      memberAccessibility.current.classList.add('user-submenu');
    memberAccessibility &&
      memberAccessibility.current.setAttribute('aria-expanded', 'true');
    memberAccessibility && memberAccessibility.current.focus();
    if (showMemberMenu) {
      memberAccessibility &&
        memberAccessibility.current.classList.remove('user-submenu');
      memberAccessibility &&
        memberAccessibility.current.removeAttribute('aria-expanded');
    }
  };

  const onCloseMemberMenu = event => {
    event.preventDefault();
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('adaMenu')) {
        return;
      } else {
        memberAccessibility &&
          memberAccessibility.current.classList.remove('user-submenu');
        memberAccessibility &&
          memberAccessibility.current.removeAttribute('aria-expanded');
        setShowMemberMenu(false);
      }
    }
  };

  const handleLogoutClick = (event = { preventDefault() {} }) => {
    event.preventDefault();
    props.clearUserData();
    logOutUser2().finally(() => {
      if (API.ALLOW_HOME_DELIVERY) {
        window.location.assign(`${decodeURI(API.GENIUS_AJAX_LOGOUT_URL)}`);
      } else {
        //logoutUser();
        onLogOut();
        showHideHamburgerMenu(false);
        toast.success(t('Logged Out'));
        setTimeout(() => {
          lang === 'es'
            ? window.location.assign('/es')
            : window.location.assign('/');
        }, 1000);
      }
    });
  };

  const toggleSearch = () => {
    setShowMobileSearchBar(showMobileSearchBar => !showMobileSearchBar);
  };

  const handleSearchSubmitOverLay = () => {
    setShowMobileSearchBar(true);
    setIsDrugPageLoading(true);
  };

  const openLoginDropDown = event => {
    event.preventDefault();
    signInModal && signInModal.current.classList.remove('hide');
    signInButton && signInButton.current.classList.add('updateButton');
    signInModal && signInModal.current.setAttribute('aria-expanded', 'true');
    signInModal && signInModal.current.focus();
  };

  const hideLoginDropDown = event => {
    event.preventDefault();
    if (
      !_.isEmpty(event.relatedTarget) &&
      event.currentTarget.className.includes('sc-top-item') &&
      event.relatedTarget === window
    ) {
      return;
    }
    signInModal && signInModal.current.classList.add('hide');
    signInButton && signInButton.current.classList.remove('updateButton');
    signInModal && signInModal.current.removeAttribute('aria-expanded');
  };

  const openLoginDropDownonClick = event => {
    event.preventDefault();

    setShowLoginDropDown(!showLoginDropDown);
    signInModal && signInModal.current.classList.remove('hide');
    signInModalAccessibility &&
      signInModalAccessibility.current.setAttribute('aria-expanded', 'true');
    signInModalAccessibility && signInModalAccessibility.current.focus();
    if (showLoginDropDown) {
      signInModal && signInModal.current.classList.add('hide');
      signInModalAccessibility &&
        signInModalAccessibility.current.removeAttribute('aria-expanded');
    }
  };

  const hideLoginDropDownKB = event => {
    event.preventDefault();
    if (!_.isEmpty(event.target.offsetParent)) {
      let offsetClassName = event.target.offsetParent.className;
      if (event.relatedTarget.className.includes('sc-form__icon')) {
        return;
      }
      if (offsetClassName === 'SigninModalWrap') {
        signInModal && signInModal.current.classList.add('hide');
        signInModalAccessibility &&
          signInModalAccessibility.current.removeAttribute('aria-expanded');
        setShowLoginDropDown(false);
      }
    }
  };

  const hideToaster = (event = { preventDefault() {} }) => {
    event.preventDefault();
    setShowErrorMsg(false);
  };

  const showHeaderText = () => {
    setShowErrorMsg(true);
  };

  const truncateString = (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + '...';
  };

  const handleDropDownClick = () => {
    setIsDrugPageLoading(true);
  };

  const showHideHamburgerMenu = value => {
    setShowHamburgerMenu(value);
  };

  const showSignUpModalFromHamburger = isSigninClick => {
    setIsSigninClick(isSigninClick);
    showHideHamburgerMenu(false);
    isSigninClick
      ? setIsSignupModalOpen(true)
      : setReferralSignupScreenFromHamburger();
  };

  const setReferralSignupScreenFromHamburger = async () => {
    const code = _.getCookie('refCode');
    if (!_.isEmpty(code)) {
      await getReferralUSerDetails(code);
    }
    setIsSignupModalOpen(true);
  };

  const handleNavBarItemClickDataEvent = () => {
    _.triggerGTMVirtualPageViewEvent({
      event: 'navBarItemClick'
    });
  };

  const handleNavMenuOpenDataEvent = () => {
    _.triggerGTMVirtualPageViewEvent({
      event: 'navMenuOpen'
    });
  };

  const handleHamburgerMenuSignUpDataEvent = () => {
    let { signUpPath, signUpPathWithInvite } =
      _.getSignUpPath(HAMBURGER_MENU_MODAL);
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
    _.triggerGTMVirtualPageViewEvent({
      event: 'signupModalOpen',
      referralLink: _.getReferralLink(referralCode),
      ...signUpPathWithInvite
    });
    props.dispatchHamburgerMenuSignupModal();
  };

  const handleNavMenuItemClick = text => {
    _.triggerGTMVirtualPageViewEvent({
      event: 'navMenuItemClick',
      clickText: text
    });
  };

  const getReferralUSerDetails = async refCode => {
    try {
      let response = await getReferrerDetails(refCode);
      if (response && response.firstName) {
        setReferrerUser(response);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSignupModal = () => {
    setIsSigninClick(false);
    setIsSignupModalOpen(true);
    let { signUpPath, signUpPathWithInvite } =
      _.getSignUpPath(NAVBAR_SIGNUP_MODAL);
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
    _.triggerGTMVirtualPageViewEvent({
      event: 'signupModalOpen',
      referralLink: _.getReferralLink(referralCode),
      ...signUpPathWithInvite
    });
    _.sendIntellimizeEvent(INTELLIMIZE_LOYALTY_SIGN_UP_STARTED);
    props.dispatchNavBarSignupModal();
  };

  const handleSignupClick = () => {
    const code = _.getCookie('refCode');
    if (!_.isEmpty(code)) {
      setReferralSignupScreen(code);
    } else {
      handleSignupModal();
    }
  };

  const setReferralSignupScreen = async code => {
    await getReferralUSerDetails(code);
    handleSignupModal();
  };

  const hideAuthenticateModal = () => {
    setIsSignupModalOpen(false);
  };

  /**
     * To define any mneu use below structure
     * ---  {
              name: name of menu,
              icon: menu icon,
              url: link url
              check: [] - any condition check like lang, user specific menu
              type: "link"/"function" - menu type is function or link
              others: all others properties for tag like event,target
            }
       --- if there is no value for key/property do not add it, like if no
           icon do not add icon:"" just remove it
     *
  */

  const getLoginMenu = () => {
    return [
      {
        name: t('Sign up free text'),
        check: [],
        icon: 'homepage-new/right-arrow.svg',
        type: MENU_TYPE_FUNCTION,
        others: {
          onClick: () => {
            showSignUpModalFromHamburger(false);
            handleHamburgerMenuSignUpDataEvent();
            handleNavMenuItemClick('Sign up');
          }
        }
      },
      {
        name: t('Log in'),
        icon: 'homepage-new/userIcon.svg',
        check: [],
        type: MENU_TYPE_FUNCTION,
        others: {
          onClick: () => {
            showSignUpModalFromHamburger(true);
            handleNavMenuItemClick('Sign in');
          }
        }
      }
    ];
  };

  const getMenuList = () => {
    return [
      {
        name: t('Saved coupons'),
        icon: 'header/saved-coupons.svg',
        url: _.withLocale(lang, '/save-drugs'),
        check: [MENU_CHECK_LANG],
        type: MENU_TYPE_LINK,
        others: {
          onClick: () => handleNavMenuItemClick('Saved coupons + drugs')
        }
      },
      {
        name: t('Saved drugs'),
        icon: 'header/saved-drugs.svg',
        url: _.withLocale(lang, '/save-drugs?drug=true'),
        check: [MENU_CHECK_LANG],
        type: MENU_TYPE_LINK,
        others: {
          onClick: () => handleNavMenuItemClick('Saved coupons + drugs')
        }
      },
      {
        name: t('Account activity'),
        icon: 'header/account-activity.svg',
        url: _.withLocale(lang, '/member-center'),
        check: [],
        type: MENU_TYPE_LINK,
        others: {
          onClick: () => handleNavMenuItemClick('Bonus savings balance')
        }
      },
      {
        name: t('Home delivery dashboard'),
        icon: 'header/icon-hand-drawn-location-outline.png',
        url: API.GENIUS_RX,
        check: [MENU_CHECK_ALLOW_HOME_DELIVERY],
        type: MENU_TYPE_LINK,
        others: {
          target: '_blank',
          rel: 'noopener noreferrer',
          onClick: () => handleNavMenuItemClick('Home delivery dashboard')
        }
      },
      {
        name: t('Profile'),
        icon: 'header/profile.svg',
        url: _.withLocale(lang, '/account-setting'),
        check: [],
        type: MENU_TYPE_LINK,
        others: {
          onClick: () => handleNavMenuItemClick('Profile')
        }
      },
      {
        name: t('Communication preferences'),
        icon: 'header/communicationPreference.svg',
        url: _.withLocale(lang, '/communications-preferences'),
        check: [MENU_CHECK_LANG],
        type: MENU_TYPE_LINK,
        others: {
          onClick: () => handleNavMenuItemClick('Communication preferences')
        }
      },
      {
        name: t('Log-out'),
        check: [],
        type: MENU_TYPE_FUNCTION,
        others: {
          onClick: () => {
            handleLogoutClick();
            handleNavMenuItemClick('Sign out');
          }
        }
      }
    ];
  };

  const getBottomMenu = () => {
    return [
      {
        name: i18n.language === 'en' ? 'Español' : 'English',
        url: `${
          i18n.language === 'en'
            ? _.withLocale('es', pathname)
            : _.withLocale('en', pathname)
        }${location.search}`,
        check: [],
        icon: '',
        type: MENU_TYPE_LINK
      },
      {
        name: t('Log out'),
        icon: '',
        check: [MENU_CHECK_USER],
        type: MENU_TYPE_FUNCTION,
        others: {
          onClick: () => {
            handleLogoutClick();
            handleNavMenuItemClick('Log out');
          }
        }
      }
    ];
  };

  const handleKeyDownForQRCode = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      enableQRCodeSection();
    } else if (e.key === 'Escape') {
      disableQRCodeSection();
    }
  };

  const enableQRCodeSection = () => {
    document
      .getElementById('qr-code-section')
      .classList.add('visibleQRCodeSection');
    setVisibleQRCode(true);
  };

  const disableQRCodeSection = () => {
    document
      .getElementById('qr-code-section')
      .classList.remove('visibleQRCodeSection');
    setVisibleQRCode(false);
  };

  const hideQRCodeSection = event => {
    if (
      !_.isEmpty(event.relatedTarget) &&
      (event.relatedTarget.className.includes('hamburgerWrap') ||
        event.relatedTarget.className.includes('qrcode-button'))
    ) {
      disableQRCodeSection();
    }
  };

  return (
    <div>
      {showErrorMsg && <LoginErrorPopup hideToaster={hideToaster} />}
      {_.isHeaderAndFooterVisible(pathname) && _.isHeaderVisible(pathname) && (
        <div className="headerv2">
          <div className="header-top homepage-header headerNew">
            <div className="main-header--submenu">
              {showMobileSearchBar && (
                <div
                  id="mobile-overlay-search"
                  className="mobile-overlay-search"
                >
                  {!isDrugPageLoading ? (
                    <SearchBar
                      showMobileSearchBar={showMobileSearchBar}
                      history={history}
                      handleZipCodeChange={value => props.toggleZipcode(value)}
                      handleSearchSubmitOverLay={handleSearchSubmitOverLay}
                      showZipCode={
                        !routes.zipCodePaths.includes(pathname.toLowerCase())
                      }
                      shouldFocus
                      handleDropDownClick={handleDropDownClick}
                      isFromHeader={true}
                      inputPlaceHolder={t('Search your drug name1')}
                    />
                  ) : (
                    <div className="loaderCenter headerLaoder">
                      <img
                        src="/content/images/loader/loading.gif"
                        alt="loader"
                        className="center"
                      />
                    </div>
                  )}
                </div>
              )}
              <div
                className="sc-header public"
                id="sc-header-search"
                role="banner"
                aria-label="Page header"
              >
                <nav id="main-header" className="sc-header-top">
                  <div className="headerInnerWrap">
                    {_.isHeaderForLandingPage(pathname) && (
                      <ul className="smallTabletsOnly">
                        <li className="sc-top-item right close-search">
                          {showMobileSearchBar && !isDrugPageLoading ? (
                            <button
                              type="button"
                              className="close"
                              onClick={toggleSearch}
                            >
                              <img
                                src="/content/images/icons/icon-close-white.svg"
                                alt=""
                                height="16"
                                width="16"
                                aria-hidden="true"
                              />
                            </button>
                          ) : (
                            <button
                              className="magnifier-close whiteFocus"
                              onClick={toggleSearch}
                              id="mobile-search-icon"
                            >
                              <span className="mobile-header-icon d-flex"></span>
                            </button>
                          )}
                        </li>
                      </ul>
                    )}
                    <ul>
                      <li className="topLogoIcon">
                        <a
                          href={_.withLocale(lang, '/')}
                          data-mp-text="Top-left Header logo"
                          className="sc-logo"
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              handleNavBarItemClickDataEvent();
                            }
                          }}
                          onClick={() => {
                            handleNavBarItemClickDataEvent();
                          }}
                          tabIndex="0"
                        >
                          <img
                            src="/content/images/header/single-care-logo1.svg"
                            width="145"
                            height="24"
                            alt="SingleCare"
                          />
                        </a>
                      </li>
                    </ul>

                    <div
                      className={`${
                        pathname.includes('/prescription/') ||
                        pathname.includes('/medicamento/')
                          ? 'prescriptionSearchBar'
                          : ''
                      }`}
                    >
                      {showSearch &&
                        pathname !== '/basket' &&
                        pathname !== '/medicareD' &&
                        pathname !== '/es/canasta' &&
                        _.isHeaderForLandingPage(pathname) && (
                          <div className="desktop-only headerSearchBar">
                            <SearchBar tabIndex="5" showZipCode={false} />
                          </div>
                        )}
                    </div>

                    {pathname !== '/tvcampaign' && (
                      <ul className="aboveTabletsOnly mainHeader headerOptions">
                        <li>
                          <a
                            href={`#${t('ID CONTENT')}`}
                            className="skipTolink whiteFocus"
                            tabIndex="1"
                          >
                            {t('Skip to content')}
                          </a>
                        </li>
                        {_.isEmpty(userName) && (
                          <li className="sc-top-item listPadding right">
                            <a
                              className="signup-button whiteFocus"
                              tabIndex="0"
                              onClick={() => handleSignupClick()}
                              onKeyDown={e => {
                                if (e.key === 'Enter') {
                                  handleSignupClick();
                                }
                              }}
                            >
                              <span>{t('Sign up')}</span>
                            </a>
                          </li>
                        )}
                        <li>
                          <div className="menu-list">
                            {!_.isEmpty(userName) ? (
                              <span
                                className={`user-name ${
                                  (_.isEmpty(userPoints) ||
                                    userPoints.amount < 1.0) &&
                                  'noPriceMenu'
                                }`}
                              >
                                <span
                                  className="sc-top-item right name"
                                  aria-expanded="false"
                                  aria-controls="menu-list"
                                >
                                  <span
                                    tabIndex="0"
                                    onClick={e => {
                                      onClickOpenMemberMenu(e);
                                      handleNavBarItemClickDataEvent();
                                    }}
                                    onKeyDown={e => {
                                      if (e.key === 'Enter') {
                                        onClickOpenMemberMenu(e);
                                        handleNavBarItemClickDataEvent();
                                      }
                                    }}
                                    onBlur={e => onCloseMemberMenu(e)}
                                    className={`memberLogin whiteFocus`}
                                    onMouseEnter={e => {
                                      onClickOpenMemberMenu(e);
                                    }}
                                    onMouseLeave={e => {
                                      onCloseMemberMenu(e);
                                    }}
                                  >
                                    <span className="UserName">
                                      {truncateString(userName, 8)}
                                      <img
                                        src="/content/images/icons/userNameDownArrow.svg"
                                        alt=""
                                      />
                                    </span>
                                  </span>
                                </span>
                                <Menu
                                  menu={getMenuList(false)}
                                  refElement={memberAccessibility}
                                  listOthers={{
                                    onBlur: e => onCloseMemberMenu(e)
                                  }}
                                  isAccessByUPDownKey={true}
                                  userName={userName}
                                  imageOthers={{
                                    className: 'mainMenuIcon',
                                    width: '20px',
                                    height: '20px'
                                  }}
                                />
                              </span>
                            ) : (
                              <div
                                onMouseLeave={hideLoginDropDown}
                                onMouseEnter={openLoginDropDown}
                                className="sc-top-item right signinButton"
                              >
                                <Link
                                  tabIndex="0"
                                  to="#"
                                  data-mp-text="Login"
                                  onClick={e => {
                                    openLoginDropDownonClick(e);
                                    handleNavBarItemClickDataEvent();
                                  }}
                                  className="login-button whiteFocus"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  ref={signInButton}
                                >
                                  <span className="sc-txt--white login-button--txt">
                                    {t('Log in')}
                                  </span>
                                </Link>
                                <div
                                  ref={signInModal}
                                  id="signin"
                                  className="SigninModalWrap hide"
                                >
                                  <div
                                    className="SigninModal"
                                    tabIndex="0"
                                    ref={signInModalAccessibility}
                                    onBlur={hideLoginDropDownKB}
                                  >
                                    <Login
                                      isFromHeader={true}
                                      showHeaderText={showHeaderText}
                                    />
                                    <div className="SignupLabel textCenter">
                                      {t('Not a member?')}&nbsp;
                                      <button
                                        onClick={() => handleSignupClick()}
                                        onKeyDown={e => {
                                          if (e.key === 'Enter') {
                                            handleSignupClick();
                                          }
                                        }}
                                        aria-label={t('sign-up (opens dialog)')}
                                      >
                                        {t('Header-SIGN UP TODAY!')}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </li>
                        {!_.isEmpty(userName) && (
                          <li
                            className={`userPointsRow ${
                              (_.isEmpty(userPoints) ||
                                userPoints.amount < 1.0) &&
                              'hidePriceWrapper'
                            }`}
                          >
                            <a
                              className="userPointsPrice whiteFocus"
                              href={_.withLocale(lang, '/account-setting')}
                              tabIndex="0"
                            >
                              {!_.isEmpty(userPoints) ? (
                                <span>
                                  <b>$</b>
                                  {Number(userPoints.amount).toFixed(2)}
                                </span>
                              ) : (
                                '0.00'
                              )}
                            </a>
                          </li>
                        )}
                        <li className="sc-top-item right">
                          <a
                            tabIndex="0"
                            href={_.withLocale(lang, '/how-it-works')}
                            className="sc-txt--white"
                            onClick={() => {
                              _.sendIntellimizeEvent(
                                INTELLIMIZE_HOW_IT_WORKS_CLICK
                              );
                              handleNavBarItemClickDataEvent();
                            }}
                          >
                            {t('How it works')}
                          </a>
                        </li>
                        {_.isHeaderForLandingPage(pathname) && (
                          <li className="sc-top-item right qr-section">
                            <div className="QRCodeSection" id="qr-code-section">
                              <button
                                type="button"
                                className="qrcode-button whiteFocus"
                                onKeyDown={handleKeyDownForQRCode}
                                onMouseEnter={() => enableQRCodeSection()}
                                onMouseLeave={() => disableQRCodeSection()}
                                aria-haspopup="dialog"
                                aria-expanded={visibleQRCode}
                                aria-controls="qr-code-panel"
                                onClick={() => enableQRCodeSection()}
                              >
                                {t('Get the app')}
                              </button>
                              <div className="QRCodeModalWrap">
                                <div
                                  id="qr-code-panel"
                                  className="QRcodeModal"
                                  role="dialog"
                                  aria-modal="false"
                                  aria-hidden={!visibleQRCode}
                                  onBlur={hideQRCodeSection}
                                  onMouseEnter={() => enableQRCodeSection()}
                                  onMouseLeave={() => disableQRCodeSection()}
                                >
                                  <p>{t('Scan the code para')}</p>
                                  <LazyLoadImage
                                    src="/content/images/header/qr-scanner.svg"
                                    width="232"
                                    height="232"
                                    alt="qr-scanner"
                                  />
                                  <div className="desktop-only commonTextApp">
                                    <SocialApps
                                      isApps={true}
                                      isLandingPages={true}
                                      labelText={t('Text yourself a link')}
                                      type={'mobileApps'}
                                      focusClass="whiteFocus"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )}
                      </ul>
                    )}
                    {_.isHeaderForLandingPage(pathname) && (
                      <ul>
                        <li>
                          <a
                            className={`hamburgerWrap closeDialogButton whiteFocus ${
                              showMobileSearchBar ? 'menuHide' : ''
                            }`}
                            aria-expanded={showHamburgerMenu}
                            aria-controls="menu"
                            aria-label="Open menu"
                            href="#hamburgerMenuContainer"
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                handleNavBarItemClickDataEvent();
                                handleNavMenuOpenDataEvent();
                                showHideHamburgerMenu(true);
                              }
                            }}
                            onClick={e => {
                              e.preventDefault();
                              handleNavBarItemClickDataEvent();
                              handleNavMenuOpenDataEvent();
                              showHideHamburgerMenu(true);
                            }}
                          >
                            <LazyImageWithNoscript
                              className="hamburgerMenu"
                              src={`/content/images/header/${
                                isMobileDevice
                                  ? 'menuIconNew.svg'
                                  : 'menuIcon.svg'
                              }`}
                              width={26}
                              height={26}
                              alt=""
                            />
                          </a>
                        </li>
                      </ul>
                    )}
                  </div>
                </nav>
                {!pathname.includes('/prescription/') &&
                  !pathname.includes('/medicamento/') &&
                  !routes.hideLoyalty.includes(pathname) &&
                  !_.isEmpty(userName) && (
                    <Loyalty amount={userPoints.amount} />
                  )}
              </div>
            </div>
          </div>
          {!_.isEmpty(userName) &&
            userPoints.amount > 1.0 &&
            !pathname.includes('/prescription/') &&
            !pathname.includes('/medicamento/') &&
            !routes.hideLoyalty.includes(pathname) && (
              <div className="Topbanner"></div>
            )}
        </div>
      )}
      {isSignupModalOpen && (
        <div className="mainModal afterSignupmodal">
          <div
            className="transparentBg"
            onClick={() => setIsSignupModalOpen(false)}
          ></div>
          <div className="signUpModal">
            <AuthenticatedModal
              referrerUser={referrerUser}
              isSigninClick={isSigninClick}
              hideAuthenticateModal={hideAuthenticateModal}
            />
          </div>
        </div>
      )}
      {showHamburgerMenu &&
        _.isHeaderAndFooterVisible(pathname) &&
        _.isHeaderVisible(pathname) && (
          <HamburgerMenu
            loginMenuList={getLoginMenu()}
            bottomMenuList={getBottomMenu()}
            showHideHamburgerMenu={() => showHideHamburgerMenu(false)}
            userName={userName}
            showHamburgerMenu={showHamburgerMenu}
            userPoints={userPoints}
          />
        )}
    </div>
  );
};
const mapDispatchToProps = dispatch => {
  return {
    clearUserData: () => dispatch(logoutClearStore()),
    dispatchNavBarSignupModal: () => dispatch(modalActions.navBarSignupModal()),
    dispatchHamburgerMenuSignupModal: () =>
      dispatch(modalActions.hamburgerMenuModal())
  };
};

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  userPoints: PropTypes.any,
  onLogOut: PropTypes.func
};

export default withRouter(
  React.memo(connect(null, mapDispatchToProps)(withTranslation()(Header)))
);
